import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Kurt  from '../Pictures/Kurt.jpg';
import Tiling  from '../Pictures/Picture1.png';
import Link from '@material-ui/core/Link';



const classes= {
    root : {
        flexGrow: 1,
        padding: 5,
        backgroundColor: '#b2dfdb',
        color: '#6a737b',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 30,
        elevation: '20',
    },
    h1 : {
      margin:'left',
      align:'left',
      justify:'left',
      color: '#009688',
      paddingTop:30,
      width:'100%',
      marginBottom:20,
      
      borderTop: 'solid 0.02em',
      },
      h2 : {
        margin:'auto',
        align:'left',
        justify:'left',
        color: '#009688',
        paddingBottom:30,
        //borderBottom: 'solid 0.04em',
        width:'100%',
        marginBottom:60,
        fontStyle:'italic'
        },
    h4 : {
        margin:'auto',
        align:'left',
        justify:'left',
        color: '#4A4A4A' ,
        paddingBottom:20,
        //borderBottom: 'solid 0.02em',
        width:'100%',
        marginBottom:60
        },
        header1 : {
          margin:'left',
          align:'left',
          justify:'left',
          width:'100%',
          marginBottom:20,
          
          },
    p :{
        color: '#4A4A4A' ,
        align:'left',
        justify:'left',
        paddingBottom:0,
        width:'100%',
        marginTop:0,
        marginBottom:20,
    fontSize:18},
    pImag :{
            color: '#333333' ,
            paddingLeft: '20%',
            paddingTop: '3%',
            marginBottom:30}   
          
    }
    export class Research extends Component {
      render() {
          return ( 
              <div align="left" style={{margin:'7%'}}>          
   <Typography variant="h2" style={classes.h1}>Random Matrices and Beyond</Typography>
   <Typography variant="h4" style={classes.h2}>A conference in celebration of Kurt Johansson's 60th birthday  </Typography>

 

        <Grid container spacing={5}> 
        <Grid sm="8" item>
   <Typography variant="p" style={{fontSize:18, fontStyle:"italic", borderBottom: 'solid 0.02em #009688'}}>
     General Info 
     </Typography>
   <Grid container spacing={0} style={{marginTop:20}}>
     <Grid item style={{width:"15%", fontStyle:"italic"}}>
     <Typography variant="p" style={classes.p}>
         Dates: 
         </Typography>
     </Grid>
     <Grid item>
     <Typography variant="p" style={classes.p}>
     June 6-10, 2022  
     </Typography>
     </Grid>
     </Grid>
     <Grid container spacing={0} style={{lineHeight: 2, marginTop:0}}>
     <Grid item style={{width:"15%", fontStyle:"italic"}}>
     <Typography variant="p" style={classes.p}>
    Venue:
    </Typography>
     </Grid>
     <Grid item >
     <Typography variant="p" style={classes.p}>
   Lecture hall: <Link href="https://www.google.com/maps/place/59.350127,18.074595/&zoom=17"> K1 </Link>, KTH<br></br>
   (note that location is not at the math department)
     </Typography>
     </Grid>
     </Grid>
     <Grid container spacing={0} style={{marginTop:0}}>
     <Grid item style={{width:"15%", fontStyle:"italic"}}>
     <Typography variant="p" style={classes.p}>
    Contact:
    </Typography>
     </Grid>
     <Grid item>
     <Typography variant="p" style={classes.p}>
     rmtstockholm2021 at kth dot se
     </Typography>

     </Grid>
     <Grid container spacing={0} style={{marginTop:50}}>
     <Grid item>
     <Typography variant="p" style={{fontSize:18,fontStyle:"italic", borderBottom: 'solid 0.02em #009688'}}>
     Sponsors 
     </Typography>
     </Grid>
     <Grid item style={{ marginTop:20}}>
     <Typography variant="p" style={classes.p}>
       We thank the Marcus Wallenberg foundation for being the main sponsor of this event. We are also grateful for additional support from the Swedish Research Council (VR), KAW and KTH.  </Typography>
       </Grid>
       </Grid>
     
     </Grid>
     </Grid>
     <Grid item sm="4" style={{ alignItems:"center"}} >
     <img style={{fit: 'contain',
         flexShrink: 1,
         margin:'auto',maxHeight:'85%'}} src={Kurt} alt="missing"/>
       </Grid>
     </Grid>


     <Grid container spacing={0} style={{ marginTop:50}}>
     <Grid item style={{ width:"25%", fontStyle:"italic"}}>
     <Typography variant="p" style={{fontSize:18, fontStyle:"italic", borderBottom: 'solid 0.02em #009688'}}>
     Description 
     </Typography>
       </Grid>
      
       <Grid item style={{ marginTop:20}}>
     <Typography variant="p" style={classes.p}>
       The main themes of the conference are Random
matrices, KPZ Universality and related areas. These are fields of mathematics to which Kurt
made outstanding contributions and had a significant impact during his mathematical
career. 
The aim of this conference is to bring together leading international researchers working in these
areas, showcasing the latest results while providing a forum for future collaborations and scientific
discoveries. </Typography>
</Grid>
</Grid>
<Grid container spacing={0} style={{lineHeight: 2, marginTop:50}}>
     <Grid item style={{width:"100%"}}>
     <Typography variant="p" style={{fontSize:18, fontStyle:"italic", borderBottom: 'solid 0.02em #009688'}}>
     Organizing committee
     </Typography>
       
     </Grid>
     </Grid>
       
       <Grid container  spacing={5} style={{marginTop:20}}>
   
     <Grid item sm={6}>
     <Typography variant="p" style={classes.p}>
         Sunil Chhita (Durham University) <br/>
         Maurice Duits (KTH) <br/>
         Erik Duse (KTH)<br/>
     
     Gaultier Lambert (University of Zürich) <br/>
     Mustazee Rahman (Durham Universtiy)<br/>
     Kevin Schnelli (KTH)
     </Typography>
    </Grid>
  <Grid item sm="6">
  <img style={{transform:"rotate(45deg)",  fit: 'contain',
         flexShrink: 1,
         margin:'auto',maxHeight:'75%',
          maxWidth:'75%'}} alt="missing" src={Tiling} />

    </Grid>

     </Grid>
    



  
  </div>
          );
      }
  }
  
  export default Research;
